import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useProfileStore = create(
  persist(
    (set) => ({
      userToken: null,   // parent UserSession token (null when playing as guest)
      profile:   null,   // currently selected kid profile
      setProfile:   (profile)            => set({ profile }),
      setUserToken: (userToken)          => set({ userToken }),
      setAuth:      (userToken, profile) => set({ userToken, profile }),
      clear:        ()                   => set({ userToken: null, profile: null }),
    }),
    { name: 'kids-profile' }
  )
)
